import { __assign } from "tslib";
import * as React from 'react';
import CheckoutAdditionalService from '../../CheckoutAdditionalService/CheckoutAdditionalService';
import { useAnimalService, useServicePageProps } from '../hooks';
import { useUpsaleWarning } from '../../../Checkout/components/Checkout/Upsale/hooks';
import { ServiceType } from '../../../Checkout/components/Checkout/OrderPaidServiceCards/types';
import { useSelector } from 'react-redux';
import { getAnimalServices, getBaggageMinPrice, getBaggageServices, getOrder, getTravellers, getServicesFallbackURL, shouldRedirectToFallback } from '../../../Checkout/store/order/selectors';
import Warning from '../../../Checkout/components/Checkout/Upsale/Warning/Warning';
import ServicePage from '../../../Checkout/components/Checkout/ServicePage/ServicePage';
import ServiceCardDialog from '../../../Checkout/components/Checkout/OrderPaidServiceCards/components/ServiceCardDialog/ServiceCardDialog';
import { useTranslation } from 'react-i18next';
import { getBaggagePriceToPay } from '../../../Checkout/store/orderPrice/selectors';
import { useTheme } from '../../../theme';
import icons from '../../icons';
import { useRenderers } from '../../../renderProps';
import { AdditionalServiceType } from '../../types';
import { getTravellersMap, initI18n } from '../../../utils';
import BaggageSummary from '../../../ServiceSummary/services/BaggageSummary';
import { useCart } from '../../../Checkout/components/Checkout/Stepbar/hooks';
import { useConfig } from '../../../context';
initI18n('BaggageService');
var BaggageAdditionalService = function () {
    var _a;
    var t = useTranslation('Checkout').t;
    var minPrice = useSelector(getBaggageMinPrice);
    var issuedPrice = useSelector(getBaggagePriceToPay);
    var css = useTheme('CheckoutAdditionalService').CheckoutAdditionalServiceBaggage;
    var servicesAvailable = useConfig().global.servicesAvailable;
    var order = useSelector(getOrder);
    var travellers = useSelector(getTravellers);
    var baggageServices = useSelector(getBaggageServices);
    var servicePageProps = useServicePageProps();
    var servicesRedirectURL = useSelector(getServicesFallbackURL);
    var shouldRedirect = useSelector(shouldRedirectToFallback);
    var _b = useUpsaleWarning(), showWarning = _b.showWarning, closeWarning = _b.closeWarning, toggleWarningIfOrderConfirmed = _b.toggleWarningIfOrderConfirmed;
    var handleClick = shouldRedirect
        ? toggleWarningIfOrderConfirmed
        : servicePageProps.toggleModal.bind(null, ServiceType.Baggage);
    var animalServices = useSelector(getAnimalServices);
    var animalTotalPrice = useAnimalService(animalServices, travellers).totalPrice;
    var onDeleteItem = useCart().onDeleteItem;
    var priceTotal = React.useMemo(function () {
        var price = __assign({}, issuedPrice);
        if (servicesAvailable.animal && animalTotalPrice.amount > 0 && price.amount >= animalTotalPrice.amount) {
            price = __assign(__assign({}, price), { amount: price.amount - animalTotalPrice.amount });
        }
        if (price.amount > 0) {
            return price;
        }
        return null;
    }, [issuedPrice, animalTotalPrice]);
    var buttons = [
        {
            text: t('Change'),
            action: servicePageProps.toggleModal.bind(null, ServiceType.Baggage),
            buttonType: 'change'
        }
    ];
    var CustomCheckoutAdditionalService = useRenderers().CheckoutAdditionalService;
    var ServiceWrapper = (_a = CustomCheckoutAdditionalService === null || CustomCheckoutAdditionalService === void 0 ? void 0 : CustomCheckoutAdditionalService.CheckoutAdditionalService) !== null && _a !== void 0 ? _a : CheckoutAdditionalService;
    if (!!(servicesAvailable === null || servicesAvailable === void 0 ? void 0 : servicesAvailable.animal) && baggageServices.length === animalServices.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(BaggageSummary, { flight: order.flight, travellers: order.travellers, services: order.additionalServices, travellersById: getTravellersMap(order.travellers), onServiceDelete: onDeleteItem }, function (content) { return (React.createElement(ServiceWrapper, { addClick: showWarning ? toggleWarningIfOrderConfirmed : handleClick, buttons: buttons, icon: icons.baggageIcon, className: css.baggage, priceFrom: minPrice, isSelected: !!content, header: t('Baggage'), description: t('Transportation of impressions no limitations'), priceTotal: priceTotal, serviceType: AdditionalServiceType.Baggage }, content)); }),
        React.createElement(Warning, { open: showWarning, redirectURL: servicesRedirectURL, onClose: closeWarning }),
        React.createElement(ServicePage, null, function (childrenProps) { return (React.createElement(ServiceCardDialog, __assign({ order: servicePageProps.order, openedModal: servicePageProps.openedModal, onClose: servicePageProps.toggleModal.bind(null, null), passengers: servicePageProps.passengers, passengerLabels: servicePageProps.passengerLabels }, childrenProps, { baggageTotalPrice: priceTotal }))); })));
};
export default BaggageAdditionalService;
